<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>
<script>
import store from "./dxrj.sdk/js/kit/storeKit";
export default {
  data() {
    return {};
  },
  store,
  mounted() {},
  methods: {},
};
</script>
<style>
html,
body,
#app {
  height: 100%;
}
.el-input__inner {
  height: 32px !important;
}
.el-input__icon {
    line-height: 32px !important;
}
</style>
